import React, { FC } from "react";
import { HiOutlineExternalLink } from "react-icons/hi";
import { Transak, TransakConfig } from "@transak/transak-sdk";
import { initTransak } from "../../api/transak";
import { UserType } from "../../types";
import { showToast } from "../../utils/showToast";

interface TransakOnRampProps {
  user: UserType;
  address: `0x${string}`;
  price: number;
  setOrderData?: (orderData: any) => void;
  fiat: string;
  crypto: string;
}
const TransakOnRamp: FC<TransakOnRampProps> = ({
  user,
  address,
  price,
  setOrderData,
  fiat,
  crypto,
}) => {
  let transak: Transak;

  const handleWeb2Checkout = () => {
    // console.log(rental);

    const transakConfig: TransakConfig = initTransak(
      user,
      address,
      price,
      fiat,
      crypto
    );

    transak = new Transak(transakConfig);

    transak.init();

    // setShowPaymentOptions(false);
  };

  // To get all the events
  // Transak.on("*", (data) => {
  //   // console.log(data);
  // });

  // This will trigger when the user closed the widget
  Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE, () => {
    console.log("Transak SDK closed!");
  });

  /*
   * This will trigger when the user has confirmed the order
   * This doesn't guarantee that payment has completed in all scenarios
   * If you want to close/navigate away, use the TRANSAK_ORDER_SUCCESSFUL event
   */
  Transak.on(Transak.EVENTS.TRANSAK_ORDER_CREATED, (orderData) => {
    // console.log(orderData);
  });

  /*
   * This will trigger when the user marks payment is made
   * You can close/navigate away at this event
   */
  Transak.on(Transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
    console.log(orderData);

    if (setOrderData) {
      setOrderData(orderData);
    }

    // transak?.close();
    transak?.close();
    showToast(
      "Crypto purchased successfully. Now, proceed to pay with your wallet",
      "success"
    );
  });

  return (
    <button
      onClick={() => {
        handleWeb2Checkout();
      }}
      className="w-full bg-blue-500 text-white py-3 px-4 rounded-lg hover:bg-blue-600 transition duration-200 flex items-center justify-center space-x-2 font-semibold text-lg"
    >
      <span>Onramp with Transak</span>
      <HiOutlineExternalLink className="h-5 w-5" />
    </button>
  );
};

export default TransakOnRamp;
